<template>
  <div id="contenedor-eliminar-contrato-asunto">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Asunto </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el asunto: {{ contratoAsuntoEliminar.numero }} -
          {{ contratoAsuntoEliminar.descripcion }}?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarAsunto"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixContratoAsuntos from './mixContratoAsuntos';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarAsuntoContrato',
  mixins: [mixContratoAsuntos],
  props: {
    contratoAsuntoEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style></style>
